import { render, staticRenderFns } from "./MyCustomAudioPlayer_test.vue?vue&type=template&id=5ab4ff9e&scoped=true&"
import script from "./MyCustomAudioPlayer_test.vue?vue&type=script&lang=js&"
export * from "./MyCustomAudioPlayer_test.vue?vue&type=script&lang=js&"
import style0 from "./MyCustomAudioPlayer_test.vue?vue&type=style&index=0&id=5ab4ff9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4ff9e",
  null
  
)

export default component.exports